export const getGtmEvents = ({ gtmEl, gtmEa, gtmEaName, gtmShow = false }) => ({
  'data-gtm-ec': 'credits-business',
  'data-gtm-el': gtmEl,
  'data-gtm-ea': gtmEa,
  'data-gtm-eaname': gtmEaName,
  'data-gtm-show': gtmShow ? '1' : undefined,
});

export default getGtmEvents;
